import styled from '@emotion/styled'
import { Icon } from 'ascential-horizon'

export const TalentLink = styled('h4')(({ theme: { space } }) => ({
  marginTop: 0,
  marginBottom: space.medium,
  padding: 0,

  // makes sure brands don't apply any special styling like money2020 and pink slashes
  '&:before': {
    content: 'none',
  },
}))

export const TalentIcon = styled(Icon)(() => ({
  transform: 'rotate(90deg)',
}))

export const TalentSession = styled('div')(({ theme: { space } }) => ({
  marginBottom: space.medium,

  p: {
    marginBottom: 0,
    marginTop: 0,
  },
}))
